module.exports = __webpack_public_path__ + "static/media/shawu.fa39fc5b.svg";